import React from 'react';

const Loading = ({ size = 'md', text }) => {
  const sizeMap = {
    sm: '24px',
    md: '40px',
    lg: '60px',
  };

  return (
    <div style={styles.container}>
      <div
        className="spinner"
        style={{
          width: sizeMap[size],
          height: sizeMap[size],
        }}
      ></div>
      {text && <p style={styles.text}>{text}</p>}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    gap: '1rem',
  },
  text: {
    color: 'var(--text-light)',
    fontSize: '0.875rem',
  },
};

export default Loading;








